import React from 'react';
import {
  Box,
  Button,
  useTheme
} from '@mui/material';
import {
  MonetizationOn as SalesIcon,
  LocalMall as ProductsIcon,
  Science as FormulationsIcon,
  Inventory as InventoryIcon,
  Factory as ProductionIcon
} from '@mui/icons-material';

export default function Navigation({ activeSection, onSectionChange }) {
  const theme = useTheme();

  const sections = [
    {
      id: 'sales',
      name: 'Sales Analytics',
      icon: SalesIcon,
      color: '#2196F3'
    },
    {
      id: 'products',
      name: 'Product Analytics',
      icon: ProductsIcon,
      color: '#FF9800'
    },
    {
      id: 'inventory',
      name: 'Inventory Analytics',
      icon: InventoryIcon,
      color: '#607D8B'
    },
    {
      id: 'formulations',
      name: 'Formulation Analytics',
      icon: FormulationsIcon,
      color: '#9C27B0'
    },
    {
      id: 'production',
      name: 'Production Analytics',
      icon: ProductionIcon,
      color: '#E91E63'
    }
  ];

  return (
    <Box sx={{ 
      width: '180px',
      minWidth: '180px',
      p: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      borderRight: `1px solid ${theme.palette.grey[300]}`
    }}>
      {sections.map((section) => {
        const IconComponent = section.icon;
        const isActive = activeSection === section.id;
        
        return (
          <Button
            key={section.id}
            fullWidth
            onClick={() => onSectionChange(section.id)}
            sx={{
              justifyContent: 'flex-start',
              py: 1.5,
              px: 2,
              borderRadius: 2,
              color: isActive ? section.color : 'text.secondary',
              fontWeight: 500,
              fontSize: '0.9rem',
              backgroundColor: isActive ? `${section.color}08` : 'transparent',
              border: isActive ? `1px solid ${section.color}30` : '1px solid transparent',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: `${section.color}12`,
                color: section.color,
                borderColor: `${section.color}40`
              }
            }}
          >
            <IconComponent sx={{ 
              fontSize: 18, 
              mr: 1.5,
              color: 'inherit'
            }} />
            {section.name}
          </Button>
        );
      })}
    </Box>
  );
}